var _rect, _path, _path2, _rect2, _path3, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vrkgemeindegruen-kundenlogo-footer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 289.8,
    height: 63,
    viewBox: "0 0 289.8 63",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2195",
    "data-name": "Rechteck 2195",
    width: 289.8,
    height: 63,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13559",
    "data-name": "Pfad 13559",
    d: "M149.016,0l-25.2,63h152.46V0Z",
    fill: "#006cb7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13560",
    "data-name": "Pfad 13560",
    d: "M127.848,0H0V63H110.8L136,0ZM97.86,60.48H2.52V2.52H121.044Z",
    fill: "#006cb7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2196",
    "data-name": "Rechteck 2196",
    width: 13.524,
    height: 63,
    transform: "translate(276.276)",
    fill: "#d9eaf8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13561",
    "data-name": "Pfad 13561",
    d: "M123.816,63l25.2-63H136L110.8,63Z",
    fill: "#d9eaf8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3149",
    "data-name": "Gruppe 3149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3147",
    "data-name": "Gruppe 3147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13562",
    "data-name": "Pfad 13562",
    d: "M80.472,17.388c-.168-.168-.084,0-.084.168Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13563",
    "data-name": "Pfad 13563",
    d: "M80.388,17.472l-.084.168C80.388,17.64,80.388,17.556,80.388,17.472Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13564",
    "data-name": "Pfad 13564",
    d: "M79.968,18.648c-.084-.336.252-.588,0-.756A.473.473,0,0,0,79.968,18.648Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13565",
    "data-name": "Pfad 13565",
    d: "M80.22,18.228h-.168l.168.252Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13566",
    "data-name": "Pfad 13566",
    d: "M79.632,19.488v-.252c.252-.168.252.252.42.084.084-.336-.336-.168-.168-.588-.168,0-.168.672-.42.5C79.212,19.572,79.548,19.236,79.632,19.488Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13567",
    "data-name": "Pfad 13567",
    d: "M98.028,19.32h0Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13568",
    "data-name": "Pfad 13568",
    d: "M79.716,24.108c.084.084.168,0,.252,0Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13569",
    "data-name": "Pfad 13569",
    d: "M81.816,24.276Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13570",
    "data-name": "Pfad 13570",
    d: "M82.824,24.276Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13571",
    "data-name": "Pfad 13571",
    d: "M79.968,24.192c.084.084,0,.5.42.168v-.084c.084.084.336,0,.5,0v-.084a.309.309,0,0,1-.252-.084C80.388,23.94,80.22,24.108,79.968,24.192Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13572",
    "data-name": "Pfad 13572",
    d: "M85.932,10.752c-.084,0-.168.084-.084,0,.084-.168.252-.168.42-.252.084-.252-.084-.084-.252,0-.168.168-.252.252-.084,0a1.119,1.119,0,0,0-.252.42h.336C86.1,10.668,86.016,10.668,85.932,10.752Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13573",
    "data-name": "Pfad 13573",
    d: "M98.532,17.976h0c.084,0,.168.084.168-.252-.084-.084-.168-.084-.336,0a.505.505,0,0,1-.336-.084v.252C98.2,17.724,98.364,17.808,98.532,17.976Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13574",
    "data-name": "Pfad 13574",
    d: "M98.028,17.892h0a.26.26,0,0,0-.084.168A.26.26,0,0,0,98.028,17.892Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13575",
    "data-name": "Pfad 13575",
    d: "M91.056,8.9h0Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13576",
    "data-name": "Pfad 13576",
    d: "M90.888,29.316c0,.084,0,.084.084.168C90.972,29.4,90.972,29.316,90.888,29.316Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13577",
    "data-name": "Pfad 13577",
    d: "M98.28,20.5a.26.26,0,0,1-.084.168v.084Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13578",
    "data-name": "Pfad 13578",
    d: "M85.6,10.836Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13579",
    "data-name": "Pfad 13579",
    d: "M97.944,18.9v.588l.084-.168C97.86,19.236,98.112,18.984,97.944,18.9Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13580",
    "data-name": "Pfad 13580",
    d: "M98.952,21.336V21a.293.293,0,0,1,.084-.168c.084-.084.168-.252.252-.336-.168-.252-.588-.252-.5-.672l.252.252c0-.5-.42-.252-.42-.756,0,.168-.252-.168-.252.168a.789.789,0,0,1-.084-.756c-.084-.084-.084,0-.168,0-.168.252.168.42-.084.672l.252.168a.272.272,0,0,1-.42.168c0,.084.084.168,0,.168-.42,0,.168-.336-.252-.42v.168c-.084,0-.168,0-.168-.084h0v-.588a.771.771,0,0,1,.336-.5l.084.336c.168-.168-.084-.42-.084-.672a.082.082,0,0,0,.084-.084h-.084c0-.084,0-.084.084-.168,0-.252-.168-.5-.084-.756l-.168.084h.084c0,.168-.084.5-.252.336a.369.369,0,0,1,.084-.42c.084-.084.168-.252.252-.336.168,0,.168.084.168.252s-.084.336,0,.42c.168-.084.168-.252.084-.42a1.746,1.746,0,0,1,0-.672c.168,0,.168.168.168.336s0,.252.168.336c0-.252,0-.42-.084-.5a.909.909,0,0,1-.084-.5.181.181,0,0,1,.168.168c.084.084.084.168.168.084v-.42c.084.42.168.336.252.168.084-.084.168-.252.252.084a.629.629,0,0,0-.084-.42c-.084-.084-.168-.168-.084-.5a.887.887,0,0,1-.168.42c-.084.084-.168.168-.252,0a1.065,1.065,0,0,0-.084-.5c0-.168.168-.084.252-.084s.168.084.168-.084a1.159,1.159,0,0,0-.252-.336c-.084.084,0,.336-.168.336,0-.168-.084-.168-.252-.168h-.42a.629.629,0,0,1-.42-.084,4.736,4.736,0,0,1-1.008.336,3.105,3.105,0,0,0-.924.42c.168-.168.168-.168.084-.252s-.252-.084-.336-.168a.588.588,0,0,0,.5-.588c-.336.084-.5.42-.336.5a1.709,1.709,0,0,0-.42.084.158.158,0,0,1-.252,0c-.168-.084,0-.336-.084-.42-.336.084,0,.336-.42.336,0,0,.084-.084,0-.084-.168,0-.42.168-.42.336-.168-.168-.252-.168-.42-.084-.168,0-.084.084-.168-.168-.084.084-.084.084,0,.168,0,.084.084.084.084.168s-.084.084-.168.084a.082.082,0,0,1-.084-.084c.084,0,.084-.168.168-.084v-.252c-.084-.084-.084.084-.168.252s-.168.336-.252.252l.168-.168c0-.084.084-.084.084-.252-.084.084-.168,0-.168.252a.082.082,0,0,1-.084-.084c-.168.084-.252.252-.5.42a.082.082,0,0,1-.084-.084,1.832,1.832,0,0,1,.336-.42c-.084,0,0-.168,0-.252a.256.256,0,0,0,0-.336h0c0-.084-.084-.084-.168-.084s-.168.084-.168-.084c.168,0,.252,0,.252-.084h0V14.2c0-.084.084-.084.084-.168a.913.913,0,0,0,.084-.42v-.5a4.405,4.405,0,0,1,.168-1.428c.084,0,.168,0,.084.252.084-.168.084-.42.168-.588v-.5c0-.168-.084-.252-.084-.42V10H92.9c0-.084,0-.252-.084-.252a.082.082,0,0,0-.084-.084c0-.084-.084-.084-.084-.168a2.106,2.106,0,0,0-.588-.336,3.066,3.066,0,0,0-1.512,0c.084-.084.168-.168.252-.168H89.8a1.194,1.194,0,0,0-.5.168,1.836,1.836,0,0,0-.42.252c-.336-.084-.5,0-.588.084a.082.082,0,0,0-.084.084h-.5c-.084,0,.084-.084.084-.084a3.638,3.638,0,0,0-.42.084.293.293,0,0,0-.168.084c-.084,0-.168.084-.252.084a7.594,7.594,0,0,0-.84.924,1.836,1.836,0,0,1-.252.42,3.652,3.652,0,0,0-.336.588c-.168-.084-.168-.252-.084-.42s.168-.336.084-.42a5.3,5.3,0,0,1-.336.756c-.084-.252-.084-.084-.168-.252a.9.9,0,0,0,0,.672l.168.5c.084,0,.168-.084.168-.252.084.084.084.168.084.336v.336c0,.168-.084.42-.084.588,0-.084.168-.42.336-.252-.168.42.252.588.336.924-.252.42-.336-.336-.588-.336a.379.379,0,0,1-.5,0c-.084.336.084.672.084,1.008h-.084v.42h0a.082.082,0,0,0,.084.084c.084.084.084.252,0,.252h.084c.084.084,0,.168.168.336-.084-.084-.252-.084-.336-.168a.637.637,0,0,1,.168.336.524.524,0,0,0-.252.42.642.642,0,0,1-.168-.42c.168,0,.252.084.252-.084-.084,0-.252-.084-.252-.168.084.252-.168.42-.252.672-.168-.168-.336-.168-.336-.42-.756.168.42.672-.42.756-.42-.168.336-.336-.168-.336l.084-.084c-.42-.588-.252.42-.672.42-.084-.336.252-.252,0-.5-.42.084-.5.588-.924.5l.084-.168c-.252.084-.756,0-1.008.084,0-.084,0-.084.084-.084-.5-.084-.168.168-.588,0V16.8c.168.084.588.252.84,0-.168.168.084.252.252.42l-1.008.168s-.084.336-.252.84V18.06H80.3v.252c-.084.42-.252,1.008-.336,1.6a.524.524,0,0,1-.252-.42c-.084.168-.252.084-.336,0-.084.168-.252.588,0,.5l.084-.084c.084,0,.084.168.168.168-.084.252-.168.084-.252.084-.168.42.42.084.336.5h-.084c.084.168.084.42.168.5v.672c-.252,0-.252-.168-.168-.336.084-.252.168-.42,0-.588-.168.168-.252-.168-.336-.252,0,.084.084.252.084.336a3.638,3.638,0,0,1,.084.42s-.168.084-.168.168a.158.158,0,0,0,0,.252v-.084c.084.336.336.168.252.42a.116.116,0,0,1-.168,0c0,.252.168.168.252.252,0,.252-.252,0-.252.252.168.084.168.168.168.336a.505.505,0,0,0,.084.336c.084-.168.252,0,.5,0h.252l.084-.084h.252c-.168.084-.336.252-.336.336H80.22l-.168-.168c-.084.084,0,.168,0,.252l.084.084h.336c.336,0,.588-.084.672.168H81.4c.084,0,.168.084.42.168a.505.505,0,0,0-.084-.336c.084.084.168.084.252.168a.26.26,0,0,1,.084.168H82.4c0,.084-.084.084-.168.084.168.168.168.168.252,0-.168.168,0,.168.084.168l-.084.168a.181.181,0,0,0,.168-.168h.168c0-.084-.084-.252-.336-.336.084,0,.252.084.336.084h.252c.168,0,.252.084.336.252a1.208,1.208,0,0,0-.168.252.26.26,0,0,0,.168-.084c.084-.084.168-.168.168-.252h.084c0,.084-.084.168,0,.168v.084c.252-.252.42-.168.588-.252h-.168c.252-.168.588-.42.588-.252-.252.084-.252.168-.252.252s-.084.084-.252.168c-.168.252.084.084.252-.084.084,0,.084,0,.084.084-.084.084-.084.168-.168.252-.252.168-.084-.084-.168,0v.084c-.084,0-.084,0-.084-.084a.617.617,0,0,0-.5.168c.084,0,.084.084.168.084h.084a.629.629,0,0,1,.084.42V25.7h0a.637.637,0,0,0,.168.336h0a.26.26,0,0,1,.168.084h-.084l.168.168a1.689,1.689,0,0,0-.336.672c.084-.168.084-.168.252-.168.168.084.252.084.168.336-.084,0-.084-.168-.168,0,.084-.084.168,0,.168.084-.084.168-.084.336-.168.336v-.168c0-.084-.084.252-.168.084v.252c-.084.168-.168-.084-.168-.084.084.42.336.672.336,1.092l-.168-.084c0,.252.168.588.168.84h-.5v.084a.082.082,0,0,0-.084-.084h.588V29.4h-.588v.168a.309.309,0,0,1-.084.252c0,.168-.084.336-.084.5a.309.309,0,0,1-.084.252v1.26h0A.293.293,0,0,0,83.5,32a2.264,2.264,0,0,0,.672.588c.168-.084.42-.084.588-.168a1.16,1.16,0,0,1,.252.336A5.433,5.433,0,0,0,86.1,33.1a2.326,2.326,0,0,0,.756.084h.84a5.781,5.781,0,0,0,1.092-.168c.42-.084.42.168.672.252.252-.084.5-.084.672-.168.084,0,.168-.084.252-.084h0V31.584a.637.637,0,0,0,.168.336c.084.084.168.084.168-.168-.084-.168-.252-.252-.084-.5l.084.168c.084-.084.084-.252.168-.42v-.5a2.893,2.893,0,0,0-.336-1.68c.084-.5.336.084.42,0-.168.336,0,.252.084.336a.337.337,0,0,1,.168-.5c0-.252.084-.42-.084-.672.084.168-.084.252-.168.084.084-.168.084-.756.42-.672a18.735,18.735,0,0,1,.336-1.932c.084-.336.084-.672.168-1.008a.309.309,0,0,1,.084-.252c-.168-.168-.084,0-.168-.084-.084-.168-.084-.168,0-.168,0,0,.084,0,0-.084l.168.168v-.168a.913.913,0,0,1,.084-.42c.084.168.168.168.084.252a1.567,1.567,0,0,1,.252.336c.084.168.084.336.084.252a2.67,2.67,0,0,0-.252-.756c0-.084.084,0,.084-.084.084.084.084.168.168.252a.26.26,0,0,0,.168.084c.084.168-.252.168-.252.168v.252h0c.084.084.168.084.084.252.336-.084-.084-.168.168-.336l.252.084-.252-.084c.252-.084.336-.336.672-.168l.336-.336c0,.252.252.084.42.084L94,23.856c.252,0,.336,0,.42.168-.168.252-.168-.084-.252.168l.252.084c0-.168.168-.252,0-.336.252-.252.336-.5.924-.5.252.252-.252.252-.168.5h.42a1.836,1.836,0,0,0,.42-.252c.252-.168.336-.336.588-.336a1.08,1.08,0,0,0,.588-.084c.084,0,.084-.084.168-.084a.26.26,0,0,0,.168-.084h.168v.084h.084a.26.26,0,0,0,.168-.084c.084-.084.252-.252.336-.252v.336c.084-.168.168-.336.252-.252-.084-.084,0-.336,0-.588a3.446,3.446,0,0,0,.084-.924h-.168a4.732,4.732,0,0,1,0-1.092c0-.42-.252-.336-.42-.672a.517.517,0,0,1,.588-.084c-.084.084-.084.252-.084.5,0,.168.084.252.168.42,0,.084.084.084.084.168s.084.168.084.252c0,.168.084.336.084.588a1.64,1.64,0,0,1-.084.588c.168.252.168.168.168-.084v-.42c0-.168,0-.252.084-.336v0c0,.336,0,.84.252,1.008C99.12,21.924,98.7,21.924,98.952,21.336ZM79.716,19.824c.084-.084.168,0,.252.168,0,.168-.084.252-.084.42h0l-.084.168C79.8,20.328,79.548,20.076,79.716,19.824Zm.084,3.024h0c0,.084.084.168.084.252C79.8,23.1,79.8,23.016,79.8,22.848Zm2.436,1.512Zm.252-.588c-.084-.084-.168-.168-.168-.252h.336C82.572,23.6,82.572,23.688,82.488,23.772Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13581",
    "data-name": "Pfad 13581",
    d: "M98.868,21.5v.168C98.784,21.672,98.868,21.588,98.868,21.5Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13582",
    "data-name": "Pfad 13582",
    d: "M78.876,20.244l.084.084.084-.252A.181.181,0,0,1,78.876,20.244Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13583",
    "data-name": "Pfad 13583",
    d: "M79.884,24.864a.256.256,0,0,0,.336,0L79.8,24.7C79.716,24.7,79.8,24.78,79.884,24.864Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13584",
    "data-name": "Pfad 13584",
    d: "M81.648,24.948c0-.084.084-.084.168-.084H81.9c.084,0,.168.084.168-.084C81.984,24.864,81.732,24.7,81.648,24.948Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13585",
    "data-name": "Pfad 13585",
    d: "M83.244,24.276c-.084.168-.084.168-.168.084a.293.293,0,0,1,.084-.168c-.168.168-.168.084-.336.168.084,0,.084.084.168.084l.084.084a.157.157,0,0,1,0,.252C83.076,24.7,83.328,24.444,83.244,24.276Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13586",
    "data-name": "Pfad 13586",
    d: "M83.5,24.78V24.7c-.084.084-.168.084-.252.168-.084,0-.084.084-.168.168A1.836,1.836,0,0,1,83.5,24.78Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13587",
    "data-name": "Pfad 13587",
    d: "M83.916,27.468c-.084-.084-.168.252-.084.084C83.916,27.552,84,27.384,83.916,27.468Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13588",
    "data-name": "Pfad 13588",
    d: "M93.24,24.444c.168.084.252,0,.252-.168C93.24,24.276,93.408,24.36,93.24,24.444Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13589",
    "data-name": "Pfad 13589",
    d: "M93.744,24.36l.084.084-.168-.168Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13590",
    "data-name": "Pfad 13590",
    d: "M94.836,24.612c0-.084.084-.084,0,0Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13591",
    "data-name": "Pfad 13591",
    d: "M94.668,24.528v.084s.084,0,0-.084C94.752,24.612,94.668,24.612,94.668,24.528Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13592",
    "data-name": "Pfad 13592",
    d: "M95,24.7l.168-.168-.252-.252C94.752,24.444,95.256,24.444,95,24.7Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13593",
    "data-name": "Pfad 13593",
    d: "M97.776,23.688h0c.084,0,.084,0,.084-.084s0-.084.084-.168a.082.082,0,0,1-.084.084c-.084.084-.084.084-.084.168,0-.084-.084-.084,0,0-.168-.084-.168,0-.252,0a.309.309,0,0,0-.084.252c0,.168-.084.336-.5.336.252.084.168.084.084.168-.168,0-.42,0-.5.084h.5l.084-.084c.168-.084.336-.168.5,0,.42-.168.252-.252.168-.42-.084-.084-.084-.084-.084-.168S97.692,23.772,97.776,23.688Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13594",
    "data-name": "Pfad 13594",
    d: "M96.684,24.024c-.168,0-.42-.252-.5-.084C96.18,24.108,96.6,24.108,96.684,24.024Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13595",
    "data-name": "Pfad 13595",
    d: "M98.28,23.94l.252-.168-.084-.168Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13596",
    "data-name": "Pfad 13596",
    d: "M98.784,22.932a.757.757,0,0,0,.084.42C98.868,23.184,99.036,22.764,98.784,22.932Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13597",
    "data-name": "Pfad 13597",
    d: "M99.372,21h0a.082.082,0,0,0-.084-.084H99.2V21a.293.293,0,0,1,.168-.084c.084,0,.084,0,.084.168-.084.084-.084.084-.084-.084Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13598",
    "data-name": "Pfad 13598",
    d: "M98.784,18.648c0,.084.084.252.168.252l-.084-.336Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13599",
    "data-name": "Pfad 13599",
    d: "M97.776,18.732c-.252.084,0,.336-.084.5A.909.909,0,0,0,97.776,18.732Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13600",
    "data-name": "Pfad 13600",
    d: "M99.12,18.312c.084.084,0,.252,0,.336C99.288,18.564,99.288,18.312,99.12,18.312Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13601",
    "data-name": "Pfad 13601",
    d: "M99.036,17.556c.084-.168.168,0,.168-.168A1.494,1.494,0,0,0,99.12,16.3c-.084.168-.336.42-.5.336a3.653,3.653,0,0,0,.336.588.4.4,0,0,1-.084.5l.42.42v-.168c0-.084-.084-.084-.084-.168C99.12,17.724,99.036,17.724,99.036,17.556Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13602",
    "data-name": "Pfad 13602",
    d: "M98.112,18.144c-.336.084.084.336.084.42l.168-.168C98.2,18.4,98.2,18.228,98.112,18.144Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13603",
    "data-name": "Pfad 13603",
    d: "M97.692,14.616h0Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13604",
    "data-name": "Pfad 13604",
    d: "M98.028,14.448l.084-.084c-.168.084-.336.084-.5.168Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13605",
    "data-name": "Pfad 13605",
    d: "M97.944,14.28l-.5.084h.084Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13606",
    "data-name": "Pfad 13606",
    d: "M96.768,14.364c-.168.084-.5.168-.588.084l.084.084C96.432,14.448,96.768,14.532,96.768,14.364Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13607",
    "data-name": "Pfad 13607",
    d: "M82.4,16.716a.309.309,0,0,0-.084-.252C82.068,16.632,82.32,16.716,82.4,16.716Z",
    fill: "#a5cf4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13608",
    "data-name": "Pfad 13608",
    d: "M82.4,16.716Z",
    fill: "#a5cf4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3148",
    "data-name": "Gruppe 3148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13609",
    "data-name": "Pfad 13609",
    d: "M11.088,23.94a27.472,27.472,0,0,1,3.7-.336,20.889,20.889,0,0,1,3.948.336l1.932,18.984L26.292,30.66a15.984,15.984,0,0,0,1.344-3.78,14.092,14.092,0,0,0,.252-2.436v-.588c.588-.084,1.176-.168,1.848-.252a17.557,17.557,0,0,1,2.1-.084,19.542,19.542,0,0,1,4.032.336v.252a7.872,7.872,0,0,1-.588,2.856,43.268,43.268,0,0,1-2.016,4.284L23.184,49.9a16.312,16.312,0,0,1-2.016.168c-.672,0-1.26.084-1.764.084H17.556A7.351,7.351,0,0,1,15.54,49.9Z",
    fill: "#006cb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13610",
    "data-name": "Pfad 13610",
    d: "M37.968,35.028c.336-2.1.672-3.948.84-5.628q.252-2.394.252-3.78V24.7a3.151,3.151,0,0,0-.084-.84,21.662,21.662,0,0,1,3.276-.336,9.13,9.13,0,0,1,1.512.084,12.443,12.443,0,0,1,1.6.252,3.02,3.02,0,0,1,.168.924,8.707,8.707,0,0,1,.084,1.68v.924c0,.336-.084.672-.084,1.092a11.471,11.471,0,0,1,1.26-1.764,15.094,15.094,0,0,1,1.68-1.6,6.746,6.746,0,0,1,2.016-1.092A7.919,7.919,0,0,1,53,23.6a5.232,5.232,0,0,1,1.764.252c0,.168.084.252.084.42v.42a12.155,12.155,0,0,1-.336,2.94,12.3,12.3,0,0,1-.924,2.52c-.168,0-.42-.084-.672-.084s-.5-.084-.924-.084a7.7,7.7,0,0,0-3.36.672,5.589,5.589,0,0,0-2.184,2.016,9.64,9.64,0,0,0-1.344,3.108,36.259,36.259,0,0,0-.924,4.032L42.336,49.9a30.172,30.172,0,0,1-3.7.336A15.459,15.459,0,0,1,35.2,49.9Z",
    fill: "#006cb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13611",
    "data-name": "Pfad 13611",
    d: "M58.548,22.932a53.667,53.667,0,0,0,.924-7.98v-.924c0-.252-.084-.5-.084-.84.588-.084,1.26-.168,1.932-.252a16.211,16.211,0,0,1,1.932-.084,14.75,14.75,0,0,1,3.192.336A6.342,6.342,0,0,1,66.7,15.12a27.429,27.429,0,0,1-.588,5.376L60.9,49.9a26.276,26.276,0,0,1-3.7.336A15.96,15.96,0,0,1,53.76,49.9Zm5.8,13.356L69.636,29.4a11.709,11.709,0,0,0,1.932-3.276,10.779,10.779,0,0,0,.588-2.184,8.285,8.285,0,0,1,2.016-.252c.588,0,1.26-.084,1.932-.084a15.526,15.526,0,0,1,1.932.084,10.924,10.924,0,0,1,1.848.252,7.327,7.327,0,0,1-.924,2.688,38.829,38.829,0,0,1-2.268,3.444l-5.04,6.3L76.44,49.9c-.672.084-1.344.084-1.932.168a12.406,12.406,0,0,1-1.764.084,13.006,13.006,0,0,1-1.848-.084,15.085,15.085,0,0,1-1.848-.168Z",
    fill: "#006cb7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3150",
    "data-name": "Gruppe 3150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13612",
    "data-name": "Pfad 13612",
    d: "M187.4,23.016a5.129,5.129,0,0,0,1.092.252q2.016,0,2.016-2.52V9.24h2.016V20.832c0,2.52-1.092,4.284-3.444,4.284a12.625,12.625,0,0,1-1.68-.168Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13613",
    "data-name": "Pfad 13613",
    d: "M196.812,19.824c0,2.688,1.008,3.864,3.108,3.864a5.092,5.092,0,0,0,2.6-.924l.084,1.68a8.041,8.041,0,0,1-3.192.672c-3.024,0-4.62-2.268-4.62-5.88s1.6-5.88,4.452-5.88c2.6,0,4.032,2.1,4.032,5.46v1.008Zm4.62-1.512c0-2.352-.756-3.612-2.268-3.612-1.176,0-2.268.924-2.352,3.612Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13614",
    "data-name": "Pfad 13614",
    d: "M210.5,24.864a4.891,4.891,0,0,1-1.6.252c-1.764,0-2.688-.672-2.688-2.688V15.036h-1.848V13.524h1.848V11.172l1.932-.588v2.94H210.5v1.512h-2.352v6.8c0,1.344.336,1.764,1.176,1.764a4.1,4.1,0,0,0,1.176-.252Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13615",
    "data-name": "Pfad 13615",
    d: "M218.652,13.524V15.2l-5.292,8.148h5.46v1.6h-7.392v-1.68l5.292-8.148H211.6v-1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13616",
    "data-name": "Pfad 13616",
    d: "M225.876,24.864a4.891,4.891,0,0,1-1.6.252c-1.764,0-2.688-.672-2.688-2.688V15.036h-1.848V13.524h1.848V11.172l1.932-.588v2.94h2.352v1.512h-2.352v6.8c0,1.344.336,1.764,1.176,1.764a4.1,4.1,0,0,0,1.176-.252v1.512Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13617",
    "data-name": "Pfad 13617",
    d: "M152.8,38.136h2.184l-4.536,5.124,4.956,6.384h-2.352l-4.2-5.8h-.084v5.8H147V32.76h1.932v10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13618",
    "data-name": "Pfad 13618",
    d: "M157.5,44.52c0,2.688,1.008,3.864,3.108,3.864a5.092,5.092,0,0,0,2.6-.924l.084,1.68a8.041,8.041,0,0,1-3.192.672c-3.024,0-4.62-2.268-4.62-5.88s1.6-5.88,4.452-5.88c2.6,0,4.032,2.1,4.032,5.46V44.52Zm4.536-1.512c0-2.352-.756-3.612-2.268-3.612-1.176,0-2.268.924-2.352,3.612Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13619",
    "data-name": "Pfad 13619",
    d: "M165.9,40.656c0-.84-.084-1.68-.084-2.52h1.848l.084,1.68h.084a2.9,2.9,0,0,1,2.94-1.848c2.016,0,3.36,1.176,3.36,3.7v7.98H172.2V42.252c0-1.848-.672-2.6-1.932-2.6-1.512,0-2.436,1.008-2.436,3.108v6.888H165.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13620",
    "data-name": "Pfad 13620",
    d: "M176.736,40.656c0-.84-.084-1.68-.084-2.52H178.5l.084,1.68h.084a2.9,2.9,0,0,1,2.94-1.848c2.016,0,3.36,1.176,3.36,3.7v7.98h-1.932V42.252c0-1.848-.672-2.6-1.932-2.6-1.512,0-2.436,1.008-2.436,3.108v6.888h-1.932Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13621",
    "data-name": "Pfad 13621",
    d: "M188.832,44.52c0,2.688,1.008,3.864,3.108,3.864a5.092,5.092,0,0,0,2.6-.924l.084,1.68a8.041,8.041,0,0,1-3.192.672c-3.024,0-4.62-2.268-4.62-5.88s1.6-5.88,4.452-5.88c2.6,0,4.032,2.1,4.032,5.46V44.52Zm4.62-1.512c0-2.352-.756-3.612-2.268-3.612-1.176,0-2.268.924-2.352,3.612Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13622",
    "data-name": "Pfad 13622",
    d: "M197.316,40.656c0-.84-.084-1.68-.084-2.52h1.848l.084,1.68h.084a2.9,2.9,0,0,1,2.94-1.848c2.016,0,3.36,1.176,3.36,3.7v7.98h-1.932V42.252c0-1.848-.672-2.6-1.932-2.6-1.512,0-2.436,1.008-2.436,3.108v6.888h-1.932Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13623",
    "data-name": "Pfad 13623",
    d: "M208.32,32.76h1.932V49.644H208.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13624",
    "data-name": "Pfad 13624",
    d: "M214.452,44.52c0,2.688,1.008,3.864,3.108,3.864a5.092,5.092,0,0,0,2.6-.924l.084,1.68a8.041,8.041,0,0,1-3.192.672c-3.024,0-4.62-2.268-4.62-5.88s1.6-5.88,4.452-5.88c2.6,0,4.032,2.1,4.032,5.46V44.52Zm4.536-1.512c0-2.352-.756-3.612-2.268-3.612-1.176,0-2.268.924-2.352,3.612Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13625",
    "data-name": "Pfad 13625",
    d: "M222.936,40.656c0-.84-.084-1.68-.084-2.52H224.7l.084,1.764h.084c.588-1.428,1.6-1.932,3.276-1.932v1.848a2.326,2.326,0,0,0-.756-.084c-1.428,0-2.52,1.26-2.52,3.78V49.56h-1.932v-8.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13626",
    "data-name": "Pfad 13626",
    d: "M229.488,40.656c0-.84-.084-1.68-.084-2.52h1.848l.084,1.68h.084a2.9,2.9,0,0,1,2.94-1.848c2.016,0,3.36,1.176,3.36,3.7v7.98h-1.932V42.252c0-1.848-.672-2.6-1.932-2.6-1.512,0-2.436,1.008-2.436,3.108v6.888h-1.932V40.656Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13627",
    "data-name": "Pfad 13627",
    d: "M241.668,44.52c0,2.688,1.008,3.864,3.108,3.864a5.092,5.092,0,0,0,2.6-.924l.084,1.68a8.041,8.041,0,0,1-3.192.672c-3.024,0-4.62-2.268-4.62-5.88s1.6-5.88,4.452-5.88c2.6,0,4.032,2.1,4.032,5.46V44.52Zm4.536-1.512c0-2.352-.756-3.612-2.268-3.612-1.176,0-2.268.924-2.352,3.612Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13628",
    "data-name": "Pfad 13628",
    d: "M250.152,40.656c0-.84-.084-1.68-.084-2.52h1.848l.084,1.68h.084a2.9,2.9,0,0,1,2.94-1.848c2.016,0,3.36,1.176,3.36,3.7v7.98h-1.932V42.252c0-1.848-.672-2.6-1.932-2.6-1.512,0-2.436,1.008-2.436,3.108v6.888h-1.932V40.656Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13629",
    "data-name": "Pfad 13629",
    d: "M262.668,45.444l-.336-11.508H264.6l-.336,11.508Zm-.252,1.68H264.6v2.52h-2.184Z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.bb23bed3559b1964957dc488f6f90405.svg";